module.exports = __webpack_public_path__ + "img/why-inclusive-img.51ff2981.svg";